export const buildProvenance = { "commitHash": "cba46611eae7ff39de366b7f627fc3dab95edb8d", "branchName": "refs/heads/release/2025.2", "buildDate": "2025-06-10T16:10:06.459Z", "version": "2025.2.12885" };
